export default __webpack_public_path__ + "static/media/interone.c78c6933.svg";